<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="secondary" *ngIf="hasClose">{{ closeText || "FECHAR" }}</button>
  <button class="btn-save" mat-raised-button cdkFocusInitial (click)="save()">
    {{ saveText || "SALVAR" }}
  </button>
</mat-dialog-actions>
